import { AuditDeviceType } from '@hapana/shared/schemas/audit'

export function getDeviceType(): AuditDeviceType {
  if (typeof window === 'undefined') {
    return AuditDeviceType.DESKTOP
  }

  const ua = navigator.userAgent.toLowerCase()
  const width = window.innerWidth

  const isMobileUA = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua)
  const isTabletUA = /ipad|android(?!.*mobile)/i.test(ua)

  if (isTabletUA || (width >= 768 && width < 1024 && isMobileUA)) {
    return AuditDeviceType.TABLET
  }
  if (isMobileUA || width < 768) {
    return AuditDeviceType.MOBILE
  }
  return AuditDeviceType.DESKTOP
}

export function getBrowserInfo(): { name: string; version: string } {
  if (typeof navigator === 'undefined') {
    return { name: 'unknown', version: 'unknown' }
  }

  const ua = navigator.userAgent
  let name = 'unknown'
  let version = 'unknown'

  if (ua.includes('Firefox/')) {
    name = 'Firefox'
    version = ua.match(/Firefox\/([\d.]+)/)?.[1] || 'unknown'
  } else if (ua.includes('Edg/')) {
    name = 'Edge'
    version = ua.match(/Edg\/([\d.]+)/)?.[1] || 'unknown'
  } else if (ua.includes('Chrome/')) {
    name = 'Chrome'
    version = ua.match(/Chrome\/([\d.]+)/)?.[1] || 'unknown'
  } else if (ua.includes('Safari/') && !ua.includes('Chrome')) {
    name = 'Safari'
    version = ua.match(/Version\/([\d.]+)/)?.[1] || 'unknown'
  } else if (ua.includes('MSIE') || ua.includes('Trident/')) {
    name = 'IE'
    version = ua.match(/(?:MSIE |rv:)([\d.]+)/)?.[1] || 'unknown'
  }

  return { name, version }
}

export function getOSInfo(): { name: string; version: string } {
  if (typeof navigator === 'undefined') {
    return { name: 'unknown', version: 'unknown' }
  }

  const ua = navigator.userAgent
  let name = 'unknown'
  let version = 'unknown'

  if (ua.includes('Windows NT')) {
    name = 'Windows'
    const ntVersion = ua.match(/Windows NT ([\d.]+)/)?.[1]
    const versionMap: Record<string, string> = {
      '10.0': '10/11',
      '6.3': '8.1',
      '6.2': '8',
      '6.1': '7',
    }
    version = ntVersion ? versionMap[ntVersion] || ntVersion : 'unknown'
  } else if (ua.includes('Mac OS X')) {
    name = 'macOS'
    version = ua.match(/Mac OS X ([\d_]+)/)?.[1]?.replace(/_/g, '.') || 'unknown'
  } else if (ua.includes('Linux')) {
    name = 'Linux'
    version = 'unknown'
  } else if (ua.includes('Android')) {
    name = 'Android'
    version = ua.match(/Android ([\d.]+)/)?.[1] || 'unknown'
  } else if (ua.includes('iPhone OS') || ua.includes('iPad')) {
    name = 'iOS'
    version = ua.match(/OS ([\d_]+)/)?.[1]?.replace(/_/g, '.') || 'unknown'
  }

  return { name, version }
}
